import React, { Fragment, useEffect, useState } from "react";
import { Col, Container, Row, Form, Button } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { handleScrollToTop } from "../../../../Utils/externalFunctions";
import {
  DateInputField,
  InputField,
  SelectionField,
  TextAreaField,
} from "../../../../CommonElements";

const StepSatu = ({
  formUMK,
  unitKerja,
  formattedNilai,
  handleChange,
  nextStep,
}) => {
  const [isButtonActive, setIsButtonActive] = useState(false);

  useEffect(() => {
    formUMK.dibayar_oleh = "Edina Ayuningtyas";
    if (Number(formUMK.nilai) < 25000000) {
      formUMK.disetujui_oleh = "Edina Ayuningtyas";
    } else {
      formUMK.disetujui_oleh = "Achmad Nizar Hidayanto";
    }
  }, [formUMK.nilai]);

  useEffect(() => {
    checkButton();
  }, [formUMK]);

  const checkButton = () => {
    setIsButtonActive(
      formUMK.id_unit_kerja !== "" &&
        formUMK.dibayarkan_ke !== "" &&
        formUMK.keterangan !== "" &&
        formUMK.nilai !== "" &&
        formUMK.vendor !== "" &&
        formUMK.tanggal_mulai !== "" &&
        formUMK.tanggal_selesai !== ""
    );
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Col md="12">
          <Form>
            <H5>
              <strong>Form UMK</strong>
            </H5>
            <Row>
              <Col md={6}>
                <SelectionField
                  state={formUMK}
                  label={"DPSJ"}
                  name={"id_unit_kerja"}
                  placeholder={"-------"}
                  options={unitKerja}
                  optionsName={"nama_unit_kerja"}
                  onChange={handleChange}
                  defaultValue={formUMK.id_unit_kerja}
                />
              </Col>
              <Col md={6}>
                <InputField
                  state={formUMK}
                  label={"Nilai"}
                  name={"nilai"}
                  placeholder={"Nilai"}
                  onChange={handleChange}
                  value={formattedNilai}
                />
              </Col>
              <Col md={6}>
                <DateInputField
                  state={formUMK}
                  label={"Tanggal Mulai"}
                  name={"tanggal_mulai"}
                  defaultValue={formUMK.tanggal_mulai}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <DateInputField
                  state={formUMK}
                  label={"Tanggal Selesai"}
                  name={"tanggal_selesai"}
                  defaultValue={formUMK.tanggal_selesai}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <InputField
                  state={formUMK}
                  label={"Dibayar ke"}
                  name={"dibayarkan_ke"}
                  placeholder={"Dibayarkan Ke"}
                  defaultValue={formUMK.dibayarkan_ke}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <InputField
                  state={formUMK}
                  label={"Vendor / Supplier"}
                  name={"vendor"}
                  placeholder={"vendor"}
                  defaultValue={formUMK.vendor}
                  onChange={handleChange}
                />
              </Col>
              <Col>
                <TextAreaField
                  state={formUMK}
                  label={"Keterangan"}
                  name={"keterangan"}
                  placeholder={"Keterangan"}
                  defaultValue={formUMK.keterangan}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <H5>
              <strong>Detail UMK</strong>
            </H5>
            <Row>
              <Col md={6}>
                <DateInputField
                  state={formUMK}
                  label={"Tanggal Diajukan"}
                  name={"tanggal_diajukan"}
                  defaultValue={formUMK.tanggal_diajukan}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <InputField
                  state={formUMK}
                  label={"Diajukan Oleh"}
                  name={"diajukan_oleh"}
                  placeholder={"Diajukan Oleh"}
                  defaultValue={formUMK.diajukan_oleh}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <InputField
                  state={formUMK}
                  label={"Disetujui Oleh"}
                  name={"disetujui_oleh"}
                  placeholder={"Disetujui Oleh"}
                  defaultValue={formUMK.disetujui_oleh}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <InputField
                  state={formUMK}
                  label={"Dibayar Oleh"}
                  name={"dibayar_oleh"}
                  placeholder={"Dibayar Oleh"}
                  defaultValue={formUMK.dibayar_oleh}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <div className="text-end">
              <Button
                disabled={!isButtonActive}
                onClick={() => {
                  nextStep();
                  handleScrollToTop();
                }}
              >
                Next
              </Button>
            </div>
          </Form>
        </Col>
      </Container>
    </Fragment>
  );
};
export default StepSatu;
